import { render } from "./DataTableGroup.vue?vue&type=template&id=49babd20&ts=true"
import script from "./DataTableGroup.vue?vue&type=script&lang=ts"
export * from "./DataTableGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__